import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "peruwelzStatus", "bernissartStatus", "peruwelzBadge", "bernissartBadge",
    "peruwelzPlantonStatus", "bernissartPlantonStatus", "peruwelzPlantonBadge", "bernissartPlantonBadge"
  ]
  static values = {
    holidays: Array
  }

  // Horaires d'accueil Péruwelz
  peruwelzSchedule = {
    1: { open: "08:00", close: "19:00" }, // Lundi
    2: { open: "08:00", close: "17:00" }, // Mardi
    3: { open: "08:00", close: "17:00" }, // Mercredi
    4: { open: "08:00", close: "17:00" }, // Jeudi
    5: { open: "08:00", close: "17:00" }, // Vendredi
    6: { open: "09:00", close: "13:00", condition: "firstOrThirdSaturday" }, // Samedi (1er & 3ᵉ)
    0: null // Dimanche
  }

  // Horaires planton Péruwelz
  peruwelzPlantonSchedule = {
    1: { open: "08:00", close: "19:00" }, // Lundi
    2: { open: "13:00", close: "17:00" }, // Mardi
    3: { open: "08:00", close: "17:00" }, // Mercredi
    4: { open: "13:00", close: "17:00" }, // Jeudi
    5: { open: "08:00", close: "17:00" }, // Vendredi
    6: { open: "09:00", close: "13:00", condition: "firstOrThirdSaturday" }, // Samedi (1er & 3ᵉ)
    0: null // Dimanche
  }

  // Horaires planton Bernissart
  bernissartPlantonSchedule = {
    1: { open: "08:00", close: "12:00" }, // Lundi
    2: { open: "08:00", close: "12:00" }, // Mardi
    3: { open: "13:00", close: "17:00" }, // Mercredi
    4: { open: "08:00", close: "12:00" }, // Jeudi
    5: { open: "08:00", close: "12:00" }, // Vendredi
    6: null, // Samedi
    0: null  // Dimanche
  }

  // Horaires d'accueil Bernissart
  bernissartSchedule = {
    1: { open: "08:00", close: "17:00" }, // Lundi
    2: { open: "08:00", close: "17:00" }, // Mardi
    3: { open: "08:00", close: "17:00" }, // Mercredi
    4: { open: "08:00", close: "17:00" }, // Jeudi
    5: { open: "08:00", close: "17:00" }, // Vendredi
    6: null, // Samedi
    0: null  // Dimanche
  }

  connect() {
    this.updateStatus()
    // Mettre à jour toutes les minutes
    this.interval = setInterval(() => this.updateStatus(), 60000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateStatus() {
    const now = new Date()
    const holidays = this.holidaysValue || []

    const peruwelzOpen = this.isOpen(now, this.peruwelzSchedule, holidays)
    const bernissartOpen = this.isOpen(now, this.bernissartSchedule, holidays)
    const peruwelzPlantonOpen = this.isOpen(now, this.peruwelzPlantonSchedule, holidays)
    const bernissartPlantonOpen = this.isOpen(now, this.bernissartPlantonSchedule, holidays)

    this.updateDisplay("peruwelz", peruwelzOpen)
    this.updateDisplay("bernissart", bernissartOpen)
    this.updateDisplay("peruwelzPlanton", peruwelzPlantonOpen)
    this.updateDisplay("bernissartPlanton", bernissartPlantonOpen)
  }

  isOpen(now, schedule, holidays) {
    // Vérifier si c'est un jour férié
    const dateStr = now.toISOString().split("T")[0]
    if (holidays.some(h => h.date === dateStr)) {
      return false
    }

    const dayOfWeek = now.getDay()
    const todaySchedule = schedule[dayOfWeek]

    if (!todaySchedule) {
      return false
    }

    // Vérifier la condition spéciale pour les samedis
    if (todaySchedule.condition === "firstOrThirdSaturday") {
      if (!this.isFirstOrThirdSaturday(now)) {
        return false
      }
    }

    const currentTime = now.getHours() * 60 + now.getMinutes()
    const [openH, openM] = todaySchedule.open.split(":").map(Number)
    const [closeH, closeM] = todaySchedule.close.split(":").map(Number)
    const openTime = openH * 60 + openM
    const closeTime = closeH * 60 + closeM

    return currentTime >= openTime && currentTime < closeTime
  }

  isFirstOrThirdSaturday(date) {
    const dayOfMonth = date.getDate()
    // 1er samedi: jours 1-7, 3ᵉ samedi: jours 15-21
    return (dayOfMonth >= 1 && dayOfMonth <= 7) || (dayOfMonth >= 15 && dayOfMonth <= 21)
  }

  updateDisplay(location, isOpen) {
    const statusTarget = this[`${location}StatusTarget`]
    const badgeTarget = this[`${location}BadgeTarget`]

    if (statusTarget) {
      statusTarget.textContent = isOpen ? "Ouvert" : "Fermé"
    }

    if (badgeTarget) {
      badgeTarget.classList.remove("bg-success", "bg-danger")
      badgeTarget.classList.add(isOpen ? "bg-success" : "bg-danger")
    }
  }
}
